import { Component, Input, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { CrimeDataService } from '../crime-log/crime-data.service';
import { FireDataService } from '../fire-log/fire-data.service';
import { FormBuilder, Validators } from '@angular/forms';

@Component({
  selector: 'app-delete-log',
  templateUrl: './delete-log.component.html',
  styleUrls: ['./delete-log.component.scss']
})

export class DeleteLogComponent implements OnInit {
  @Input() public sitecode;
  @Input() public type;
  public crimeCount;
  public fireCount;
  public message;

  deleteForm = this.fb.group({
    SITECODE: [''],
    DELETE_DATE: ['', Validators.required],
  });

  constructor(public dialogRef: MatDialogRef<DeleteLogComponent>,
              private fireDataService: FireDataService, private crimeDataService: CrimeDataService, private fb: FormBuilder) { }

  ngOnInit() {
  }

  closeDialog() {
    this.dialogRef.close('closed');
  }// end closeDialog

  getCrimeCount() {

    if (this.type === 'crime') {
      this.crimeDataService.getCrimesToClear(this.deleteForm.value)
      .subscribe(
        data => { this.crimeCount = data[0].COUNT; },
        err => console.error(err),
        () => {
          this.message = {
            text: 'Are you sure you wish to permanently remove ' + this.crimeCount + ' records from the database?'
          };
          console.log('crime count:' + this.crimeCount);
        }
      );
    }

    if (this.type === 'fire') {
      this.fireDataService.getFiresToClear(this.deleteForm.value)
      .subscribe(
        data => { this.fireCount = data[0].COUNT; },
        err => console.error(err),
        () => {
          this.message = {
            text: 'Are you sure you wish to permanently remove ' + this.fireCount + ' records from the database?'
          };
          console.log('fire count:' + this.fireCount);
        }
      );
    }
  }

  onSubmit() {
    if (this.type === 'crime') {
      this.crimeDataService.clearCrimes(this.deleteForm.value)
      .subscribe(() => this.closeDialog());
    }// end if

    if (this.type === 'fire') {
      this.fireDataService.clearFires(this.deleteForm.value)
      .subscribe(() => this.closeDialog());
    }// end if
  }// end onSubmit

}
